export * from './marketing-tile-list.styled.default';
